import api from './apiClient'

export default {
  getCart() {
    return api.get('/cart')
  },

  addToCart(payload) {
    return api.post('/cart', payload)
  },

  updateItem(id, payload) {
    return api.put(`/cart/${id}`, payload)
  },

  removeItem(id) {
    return api.delete(`cart/${id}`)
  }
}